export function LogoIcon({ mainClassName }) {
    return (
        <svg
            width={226}
            height={123}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 226 123"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M112.054 9.056L103.157.16a.538.538 0 00-.919.38v54.662a3.229 3.229 0 003.229 3.229h36.59a3.229 3.229 0 003.229-3.229v-36.59a3.229 3.229 0 00-3.229-3.228h-22.6c-.594 0-1.076.482-1.076 1.076v8.61c0 .594.482 1.075 1.076 1.075h13.991c.594 0 1.076.482 1.076 1.077v19.37c0 .595-.482 1.077-1.076 1.077h-19.372A1.076 1.076 0 01113 46.592V11.339c0-.856-.34-1.677-.946-2.283zM11.838 47.668h19.783c.407 0 .78.23.962.595l4.305 8.61a1.076 1.076 0 01-.963 1.557H3.23A3.229 3.229 0 010 55.2v-36.59a3.229 3.229 0 013.229-3.228H36.59c.595 0 1.077.482 1.077 1.076v8.61c0 .594-.482 1.075-1.077 1.075H11.838c-.594 0-1.076.482-1.076 1.077v19.37c0 .595.482 1.077 1.076 1.077zm69.822.946l8.898 8.897a.538.538 0 00.918-.38V18.61a3.229 3.229 0 00-3.228-3.228h-36.59a3.229 3.229 0 00-3.23 3.228v36.59a3.229 3.229 0 003.23 3.229h22.6c.594 0 1.075-.482 1.075-1.077v-8.609c0-.594-.481-1.076-1.076-1.076h-13.99a1.076 1.076 0 01-1.077-1.076V27.22c0-.595.482-1.077 1.077-1.077h19.371c.594 0 1.076.482 1.076 1.077v19.11c0 .856.34 1.677.946 2.282zm116.517 8.897l-8.898-8.898a3.23 3.23 0 01-.946-2.282V27.22c0-.595-.481-1.077-1.076-1.077h-19.371c-.595 0-1.076.482-1.076 1.077v19.37c0 .595.481 1.077 1.076 1.077h13.99c.595 0 1.076.482 1.076 1.076v8.61c0 .594-.481 1.076-1.076 1.076h-22.6a3.228 3.228 0 01-3.228-3.229v-36.59a3.228 3.228 0 013.228-3.228h36.591a3.228 3.228 0 013.228 3.228v38.52c0 .479-.579.719-.918.38zm-14.306 7.218l8.898 8.898a3.23 3.23 0 01.945 2.282v35.253c0 .594.482 1.076 1.076 1.076h19.372c.594 0 1.076-.482 1.076-1.076V91.791c0-.594-.482-1.076-1.076-1.076h-13.991a1.076 1.076 0 01-1.076-1.076v-8.61c0-.594.482-1.076 1.076-1.076h22.6A3.228 3.228 0 01226 83.182v36.589a3.228 3.228 0 01-3.229 3.229h-36.59a3.229 3.229 0 01-3.229-3.229V65.11c0-.48.58-.72.919-.38zm-108.538.38c0-.479.58-.719.919-.38l8.898 8.898c.605.605.945 1.426.945 2.282v9.425h29.057a3.229 3.229 0 013.229 3.228v33.362c0 .594-.482 1.076-1.076 1.076h-8.61a1.076 1.076 0 01-1.076-1.076V97.172c0-.594-.482-1.076-1.076-1.076H87.171c-.594 0-1.076.481-1.076 1.076v24.752c0 .594-.482 1.076-1.076 1.076h-8.61a1.076 1.076 0 01-1.076-1.076V65.11zm54.886 14.844c-.594 0-1.076.482-1.076 1.076v40.895c0 .594.482 1.076 1.076 1.076h40.895c.595 0 1.076-.482 1.076-1.076V81.029c0-.594-.481-1.076-1.076-1.076h-8.609c-.595 0-1.076.482-1.076 1.076v30.133c0 .594-.482 1.076-1.077 1.076h-19.371a1.076 1.076 0 01-1.076-1.076V81.029c0-.594-.482-1.076-1.076-1.076h-8.61z"
                fill="#fff"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M44.008 65.008l19.858 24.823c.458.572.708 1.283.708 2.016v29.619c0 .509-.64.733-.959.336L43.757 96.98a3.228 3.228 0 01-.707-2.017V65.344c0-.508.64-.733.958-.336z"
                fill="#5E21DF"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M27.866 65.008l19.858 24.823c.459.572.708 1.283.708 2.016v29.619c0 .509-.64.733-.958.336L27.616 96.98a3.228 3.228 0 01-.708-2.017V65.344c0-.508.64-.733.958-.336z"
                fill="#7B3DFF"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.722 65.008L31.58 89.831c.458.572.708 1.283.708 2.016v29.619c0 .509-.641.733-.959.336L11.471 96.98a3.228 3.228 0 01-.707-2.017V65.344c0-.508.64-.733.958-.336z"
                fill="#8F73FF"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M43.05 83.989l4.673 5.841c.458.573.708 1.284.708 2.017v10.975l-4.674-5.842a3.228 3.228 0 01-.707-2.017V83.99z"
                fill="#531CC9"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M26.908 83.989l4.674 5.841c.458.573.707 1.284.707 2.017v10.975l-4.673-5.842a3.228 3.228 0 01-.708-2.017V83.99z"
                fill="#6930E1"
            />
        </svg>
    );
}


export function LineIcon({ mainClassName }) {
    return (
        <svg
            width={44}
            height={6}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 44 6"
        >
            <path d="M4 0h40l-4 6H0l4-6z" fill="#8459FF" />
        </svg>
    );
}

export function MailIcon({ mainClassName, strokeClassName }) {
    return (
        <svg
            width={42}
            height={42}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 42 42"
        >
            <path
                d="M27.111 12H14.89C12.189 12 10 14.149 10 16.8v8.4c0 2.651 2.189 4.8 4.889 4.8H27.11c2.7 0 4.889-2.149 4.889-4.8v-8.4c0-2.651-2.189-4.8-4.889-4.8z"
                stroke="#8AFFF1"
                strokeLinecap="round"
                strokeLinejoin="round"
                className={strokeClassName}
            />
            <path
                d="M14.89 17.314l5.138 2.24a2.444 2.444 0 001.947.003l5.136-2.22"
                stroke="#8AFFF1"
                strokeLinecap="round"
                strokeLinejoin="round"
                className={strokeClassName}
            />
        </svg>
    );
}

export function TelegramIcon({ mainClassName, strokeClassName }) {
    return (
        <svg
            width={42}
            height={42}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 42 42"
        >
            <path
                d="M21.178 26.156l-2.623 2.564a.844.844 0 01-1.399-.362l-1.747-5.783"
                stroke="#fff"
                strokeLinecap="round"
                strokeLinejoin="round"
                className={strokeClassName}
            />
            <path
                d="M24.11 18.524l-4.974 4.512a1.08 1.08 0 00.084 1.666l6.83 5.071c.671.5 1.631.133 1.805-.69l3.354-15.887a.986.986 0 00-1.317-1.128L10.19 19.706c-.58.225-.553 1.058.04 1.244l5.178 1.624"
                stroke="#fff"
                strokeLinecap="round"
                strokeLinejoin="round"
                className={strokeClassName}
            />
        </svg>
    );
}

export function WhatsAppIcon({ mainClassName, strokeClassName }) {
    return (
        <svg
            width={42}
            height={42}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 42 42"
        >
            <path
                d="M19.74 19.785a7.577 7.577 0 002.475 2.475l.95-.57a1.156 1.156 0 011.316.089l1.844 1.475a1.155 1.155 0 01.088 1.726l-.833.82a3.468 3.468 0 01-4.288.463 18.728 18.728 0 01-5.554-5.555 3.468 3.468 0 01.462-4.287l.82-.834a1.155 1.155 0 011.727.088l1.474 1.844a1.156 1.156 0 01.089 1.317l-.57.95z"
                stroke="#fff"
                strokeLinecap="round"
                strokeLinejoin="round"
                className={strokeClassName}
            />
            <path
                d="M15.048 30.25l-3.117.521a.61.61 0 01-.702-.702l.52-3.117a11 11 0 113.299 3.298z"
                stroke="#fff"
                strokeLinecap="round"
                strokeLinejoin="round"
                className={strokeClassName}
            />
        </svg>
    );
}

export function LinkedInIcon({ mainClassName, strokeClassName, fillClassName }) {
    return (
        <svg
            width={42}
            height={42}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 42 42"
        >
            <path
                d="M17.314 19.431v5.4M20.911 24.831v-3.15a2.249 2.249 0 114.5 0v3.15"
                stroke="#fff"
                strokeLinecap="round"
                strokeLinejoin="round"
                className={strokeClassName}
            />
            <path
                d="M17.31 16.016a.801.801 0 10.804.8.804.804 0 00-.805-.8z"
                fill="#fff"
                className={fillClassName}
            />
            <path
                d="M28.778 13.221c4.296 4.296 4.296 11.262 0 15.558-4.296 4.295-11.261 4.295-15.557 0-4.296-4.296-4.296-11.262 0-15.558 4.296-4.295 11.261-4.295 15.557 0z"
                stroke="#fff"
                strokeLinecap="round"
                strokeLinejoin="round"
                className={strokeClassName}
            />
        </svg>
    );
}

export function MascotCircle1Icon({ mainClassName }) {
    return (
        <svg
            width={142}
            height={142}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 142 142"
        >
            <circle
                cx={71}
                cy={71}
                r={71}
                fill="url(#prefix__paint0_radial_435_1419)"
            />
            <defs>
                <radialGradient
                    id="prefix__paint0_radial_435_1419"
                    cx={0}
                    cy={0}
                    r={1}
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="matrix(-130.00105 120.99908 -120.9984 -130.00032 130 28)"
                >
                    <stop stopColor="#9039FF" />
                    <stop offset={0.155} stopColor="#7108DA" />
                    <stop offset={0.41} stopColor="#3A0074" />
                    <stop offset={0.576} stopColor="#2F005E" />
                    <stop offset={0.725} stopColor="#290151" />
                    <stop offset={0.964} stopColor="#5800AF" />
                    <stop offset={1} stopColor="#6E00DC" />
                </radialGradient>
            </defs>
        </svg>
    );
}

export function MascotCircle2Icon({ mainClassName }) {
    return (
        <svg
            width={264}
            height={264}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 264 264"
        >
            <circle
                cx={132}
                cy={132}
                r={132}
                fill="url(#prefix__paint0_radial_435_1420)"
            />
            <defs>
                <radialGradient
                    id="prefix__paint0_radial_435_1420"
                    cx={0}
                    cy={0}
                    r={1}
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="rotate(48.991 -41.622 106.427) scale(243.836 243.835)"
                >
                    <stop stopColor="#9039FF" />
                    <stop offset={0.155} stopColor="#7108DA" />
                    <stop offset={0.41} stopColor="#3A0074" />
                    <stop offset={0.576} stopColor="#2F005E" />
                    <stop offset={0.725} stopColor="#290151" />
                    <stop offset={0.964} stopColor="#5800AF" />
                    <stop offset={1} stopColor="#6E00DC" />
                </radialGradient>
            </defs>
        </svg>
    );
}

export function MascotCircle3Icon({ mainClassName }) {
    return (
        <svg
            width={34}
            height={34}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 34 34"
        >
            <circle
                cx={17}
                cy={17}
                r={17}
                fill="url(#prefix__paint0_radial_435_1421)"
            />
            <defs>
                <radialGradient
                    id="prefix__paint0_radial_435_1421"
                    cx={0}
                    cy={0}
                    r={1}
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="matrix(0 37.2692 -37.2691 0 17 .98)"
                >
                    <stop stopColor="#9039FF" />
                    <stop offset={0.155} stopColor="#7108DA" />
                    <stop offset={0.41} stopColor="#3A0074" />
                    <stop offset={0.576} stopColor="#2F005E" />
                    <stop offset={0.725} stopColor="#290151" />
                    <stop offset={0.964} stopColor="#5800AF" />
                    <stop offset={1} stopColor="#6E00DC" />
                </radialGradient>
            </defs>
        </svg>
    );
}

export function MascotSquareIcon({ mainClassName }) {
    return (
        <svg
            width={764}
            height={194}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 764 194"
        >
            <path
                d="M87 47h16v16H87V47zM591 178h16v16h-16v-16zM37 139h8v8h-8v-8zM756 43h8v8h-8v-8zM0 5h5v5H0V5zM394 0h8v8h-8V0z"
                fill="#8AFFF1"
            />
        </svg>
    );
}

export function ShareIcon({ mainClassName }) {
    return (
        <svg
            width={26}
            height={26}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 26 26"
        >
            <path
                d="M16 10h2a2 2 0 012 2v8a2 2 0 01-2 2H8a2 2 0 01-2-2v-8a2 2 0 012-2h2M13 15.2V4M15.8 6.8L13 4l-2.8 2.8"
                stroke="#fff"
                strokeWidth={1.4}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export function CameraAppleIconIcon({ mainClassName }) {
    return (
        <svg
            width={70}
            height={53}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 70 53"
        >
            <path
                d="M26 .5h18c1.2 0 2.9.8 3.6 1.8l5 7.3c.5.7 1.3 1.1 2.1 1.1h10.7c2.5 0 4.5 2 4.5 4.5v33c0 2.5-2 4.5-4.5 4.5H4.6c-2.5 0-4.5-2-4.5-4.5v-33c0-2.5 2-4.5 4.5-4.5h10.7c.8 0 1.6-.4 2.1-1.1l5-7.3c.7-1 2.3-1.8 3.6-1.8zm25.9 16c0 1.3 1 2.3 2.3 2.3 1.2 0 2.3-1 2.3-2.3 0-1.3-1-2.3-2.3-2.3-1.3 0-2.3 1-2.3 2.3zM19.2 31.3c0 8.8 7.1 15.9 15.8 15.9 8.7 0 15.8-7.1 15.8-15.9S43.7 15.4 35 15.4c-8.7 0-15.8 7.1-15.8 15.9zM6.8 2.8h4.5c1.2 0 2.2 1 2.2 2.3v2.3h-9V5.1c.1-1.3 1.1-2.3 2.3-2.3zm15.8 28.5c0-6.9 5.5-12.5 12.4-12.5s12.4 5.6 12.4 12.5S41.9 43.8 35 43.8s-12.4-5.6-12.4-12.5z"
                fill="#353535"
            />
        </svg>
    );
}

export function PartLogoIcon({ mainClassName }) {
    return (
        <svg
            width={86}
            height={92}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 86 92"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M53.132.327L84.87 40.25A5.213 5.213 0 0186 43.494v47.639c0 .818-1.023 1.18-1.531.54L52.73 51.75a5.213 5.213 0 01-1.13-3.244V.867c0-.818 1.023-1.18 1.531-.54z"
                fill="#5E21DF"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M27.334.327L59.072 40.25a5.213 5.213 0 011.13 3.244v47.639c0 .818-1.023 1.18-1.531.54L26.933 51.75a5.213 5.213 0 01-1.13-3.244V.867c0-.818 1.023-1.18 1.531-.54z"
                fill="#7B3DFF"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.532.327L33.269 40.25a5.213 5.213 0 011.13 3.244v47.639c0 .818-1.023 1.18-1.53.54L1.13 51.75A5.213 5.213 0 010 48.506V.867C0 .05 1.024-.313 1.532.327z"
                fill="#8F73FF"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M51.6 30.854l7.47 9.396a5.213 5.213 0 011.13 3.244v17.651l-7.469-9.396a5.214 5.214 0 01-1.13-3.243V30.854z"
                fill="#531CC9"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M25.803 30.854l7.469 9.396a5.214 5.214 0 011.13 3.244v17.651l-7.469-9.396a5.214 5.214 0 01-1.13-3.243V30.854z"
                fill="#6930E1"
            />
        </svg>
    );
}

export function ContactFormTriangleIcon({ mainClassName, fillClassName }) {
    return (
        <svg
            width={50}
            height={50}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 50 50"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1 0v47L48 0H1z"
                fill="#000"
                className={fillClassName}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 0v49.414L49.414 0h-2.828L2 44.586V0H0z"
                fill="#390073"
            />
        </svg>
    );
}

export function DropArrowIcon({ mainClassName, strokeClassName }) {
    return (
        <svg
            width={34}
            height={34}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 34 34"
        >
            <path
                d="M13 15l3.859 3.859a.2.2 0 00.282 0L21 15"
                stroke="#8AFFF1"
                strokeWidth={2}
                strokeLinecap="round"
                className={strokeClassName}
            />
        </svg>
    );
}

export function CloseIcon({ mainClassName, strokeClassName }) {
    return (
        <svg
            width={34}
            height={34}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 34 34"
        >
            <path
                d="M13 13l3.859 3.859a.2.2 0 00.282 0L21 13M21 21l-3.859-3.859a.2.2 0 00-.282 0L13 21"
                stroke="#8AFFF1"
                strokeWidth={2}
                strokeLinecap="round"
                className={strokeClassName}
            />
        </svg>
    );
}


export function ArrowIcon({ mainClassName }) {
    return (
        <svg
            width={70}
            height={70}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 70 70"
            className={mainClassName}
        >
            <path
                d="M42.904 19.57a2.905 2.905 0 00-4.112 0L25.404 32.959a2.905 2.905 0 000 4.113l13.388 13.387a2.905 2.905 0 004.112 0 2.905 2.905 0 000-4.112L31.587 35l11.317-11.317c1.138-1.137 1.108-3.004 0-4.112z"
                fill="#fff"
            />
        </svg>
    );
}

export const RoundArrowIcon = ({ mainClassName, fillClassName }) => {
  return (
    <svg
      className={mainClassName}
      width="68"
      height="68"
      viewBox="0 0 68 68"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className={fillClassName}
        d="M33.9658 67.8184C29.363 67.8184 25.0335 66.9411 20.9775 65.1865C16.9443 63.4548 13.3896 61.0508 10.3135 57.9746C7.2373 54.8984 4.82194 51.3438 3.06738 47.3105C1.33561 43.2546 0.469727 38.9251 0.469727 34.3223C0.469727 29.7194 1.33561 25.4014 3.06738 21.3682C4.82194 17.3122 7.2373 13.7461 10.3135 10.6699C13.3896 7.59375 16.9443 5.18978 20.9775 3.45801C25.0335 1.70345 29.363 0.826172 33.9658 0.826172C38.5687 0.826172 42.8867 1.70345 46.9199 3.45801C50.9759 5.18978 54.542 7.59375 57.6182 10.6699C60.6943 13.7461 63.1097 17.3122 64.8643 21.3682C66.6188 25.4014 67.4961 29.7194 67.4961 34.3223C67.4961 38.9251 66.6188 43.2546 64.8643 47.3105C63.1097 51.3438 60.6943 54.8984 57.6182 57.9746C54.542 61.0508 50.9873 63.4548 46.9541 65.1865C42.9209 66.9411 38.5915 67.8184 33.9658 67.8184ZM33.9658 65.2207C38.2497 65.2207 42.2601 64.4232 45.9971 62.8281C49.734 61.2331 53.0153 59.0228 55.8408 56.1973C58.6891 53.349 60.9108 50.0563 62.5059 46.3193C64.1009 42.5824 64.8984 38.5833 64.8984 34.3223C64.8984 30.0612 64.1009 26.0622 62.5059 22.3252C60.9108 18.5882 58.6891 15.2956 55.8408 12.4473C53.0153 9.59896 49.734 7.37728 45.9971 5.78223C42.2601 4.18717 38.2497 3.38965 33.9658 3.38965C29.7048 3.38965 25.7057 4.18717 21.9688 5.78223C18.2318 7.37728 14.9391 9.59896 12.0908 12.4473C9.2653 15.2956 7.05501 18.5882 5.45996 22.3252C3.86491 26.0622 3.06738 30.0612 3.06738 34.3223C3.06738 38.5833 3.86491 42.5824 5.45996 46.3193C7.05501 50.0563 9.2653 53.349 12.0908 56.1973C14.9391 59.0228 18.2318 61.2331 21.9688 62.8281C25.7057 64.4232 29.7048 65.2207 33.9658 65.2207ZM51.5684 34.2539C51.5684 34.5957 51.4316 34.9033 51.1582 35.1768L38.1357 48.165C37.8851 48.4385 37.5889 48.5752 37.2471 48.5752C36.9281 48.5752 36.6546 48.4613 36.4268 48.2334C36.2217 48.0055 36.1191 47.7321 36.1191 47.4131C36.1191 47.0713 36.2673 46.7637 36.5635 46.4902L43.3652 39.6885L47.7061 35.3818L42.6475 35.5527H17.6279C17.2406 35.5527 16.9329 35.4388 16.7051 35.2109C16.4772 34.9603 16.3633 34.6641 16.3633 34.3223C16.3633 33.9121 16.4772 33.5931 16.7051 33.3652C16.9557 33.1374 17.2633 33.0234 17.6279 33.0234H42.6475L47.7402 33.1943L43.3652 28.8877L36.5635 22.0859C36.2673 21.7897 36.1191 21.4707 36.1191 21.1289C36.1191 20.8327 36.2217 20.5706 36.4268 20.3428C36.6546 20.1149 36.9281 20.001 37.2471 20.001C37.6117 20.001 37.9079 20.1377 38.1357 20.4111L51.1582 33.3652C51.4316 33.6615 51.5684 33.9577 51.5684 34.2539Z"
        fill="#8AFFF1"
      />
    </svg>
  );
};

export const RoundCloseIcon = ({ mainClassName, fillClassName }) => {
  return (
    <svg
      className={mainClassName}
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className={fillClassName}
        d="M19.9805 39.0391C17.3503 39.0391 14.8763 38.5378 12.5586 37.5352C10.2539 36.5456 8.22266 35.1719 6.46484 33.4141C4.70703 31.6562 3.32682 29.625 2.32422 27.3203C1.33464 25.0026 0.839844 22.5286 0.839844 19.8984C0.839844 17.2682 1.33464 14.8008 2.32422 12.4961C3.32682 10.1784 4.70703 8.14062 6.46484 6.38281C8.22266 4.625 10.2539 3.2513 12.5586 2.26172C14.8763 1.25911 17.3503 0.757812 19.9805 0.757812C22.6107 0.757812 25.0781 1.25911 27.3828 2.26172C29.7005 3.2513 31.7383 4.625 33.4961 6.38281C35.2539 8.14062 36.6341 10.1784 37.6367 12.4961C38.6393 14.8008 39.1406 17.2682 39.1406 19.8984C39.1406 22.5286 38.6393 25.0026 37.6367 27.3203C36.6341 29.625 35.2539 31.6562 33.4961 33.4141C31.7383 35.1719 29.707 36.5456 27.4023 37.5352C25.0977 38.5378 22.6237 39.0391 19.9805 39.0391ZM19.9805 37.5547C22.4284 37.5547 24.7201 37.099 26.8555 36.1875C28.9909 35.276 30.8659 34.013 32.4805 32.3984C34.1081 30.7708 35.3776 28.8893 36.2891 26.7539C37.2005 24.6185 37.6562 22.3333 37.6562 19.8984C37.6562 17.4635 37.2005 15.1784 36.2891 13.043C35.3776 10.9076 34.1081 9.02604 32.4805 7.39844C30.8659 5.77083 28.9909 4.5013 26.8555 3.58984C24.7201 2.67839 22.4284 2.22266 19.9805 2.22266C17.5456 2.22266 15.2604 2.67839 13.125 3.58984C10.9896 4.5013 9.10807 5.77083 7.48047 7.39844C5.86589 9.02604 4.60286 10.9076 3.69141 13.043C2.77995 15.1784 2.32422 17.4635 2.32422 19.8984C2.32422 22.3333 2.77995 24.6185 3.69141 26.7539C4.60286 28.8893 5.86589 30.7708 7.48047 32.3984C9.10807 34.013 10.9896 35.276 13.125 36.1875C15.2604 37.099 17.5456 37.5547 19.9805 37.5547ZM12.9492 27.6914C12.7409 27.6914 12.5586 27.6198 12.4023 27.4766C12.2591 27.3333 12.1875 27.1576 12.1875 26.9492C12.1875 26.7409 12.2721 26.5521 12.4414 26.3828L18.8867 19.918L12.4414 13.4727C12.2721 13.3034 12.1875 13.1081 12.1875 12.8867C12.1875 12.6784 12.2591 12.5026 12.4023 12.3594C12.5586 12.2161 12.7409 12.1445 12.9492 12.1445C13.1836 12.1445 13.3919 12.2357 13.5742 12.418L19.9805 18.8438L26.4062 12.418C26.5885 12.2357 26.7839 12.1445 26.9922 12.1445C27.2135 12.1445 27.3958 12.2161 27.5391 12.3594C27.6953 12.5026 27.7734 12.6784 27.7734 12.8867C27.7734 13.1081 27.6888 13.3034 27.5195 13.4727L21.0742 19.918L27.5195 26.3633C27.6888 26.5456 27.7734 26.7409 27.7734 26.9492C27.7734 27.1576 27.6953 27.3333 27.5391 27.4766C27.3958 27.6198 27.2135 27.6914 26.9922 27.6914C26.7708 27.6914 26.569 27.6003 26.3867 27.418L19.9805 21.0117L13.5742 27.418C13.3919 27.6003 13.1836 27.6914 12.9492 27.6914Z"
        fill="#8A8FFF"
      />
    </svg>
  );
};